import { PaletteMode } from '@mui/material';

const palette = {
  dark: {
    '50': '#fafafa',
    '100': '#f5f5f5',
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '400': '#bdbdbd',
    '500': '#9e9e9e',
    '600': '#757575',
    '700': '#616161',
    '800': '#424242',
    '900': '#212121',
  },
};

export const darkPalette = {
  ...palette,
  contrastThreshold: 4.5,
  mode: 'dark' as PaletteMode,
  error: {
    main: '#FF8A65',
  },
  info: {
    main: '#ffffff',
  },
  primary: {
    main: palette.dark[200],
    contrastText: palette.dark[900],
  },
  secondary: {
    main: palette.dark[900],
  },
  success: {
    main: '#769E91',
  },
  warning: {
    main: '#FFD54F',
  },
  text: {
    primary: palette.dark[50],
    secondary: palette.dark[100],
    disabled: palette.dark[300],
  },
  divider: palette.dark[700],
  background: {
    paper: palette.dark[900],
    default: palette.dark[800],
  },
  action: {
    selectedOpacity: 0,
    selected: palette.dark[800],
  },
};

export const lightPalette = {
  ...palette,
  contrastThreshold: 3,
  mode: 'light' as PaletteMode,
  error: {
    main: '#FF5252',
  },
  info: {
    main: '#273D37',
  },

  primary: {
    main: '#769E91',

    contrastText: '#FFF',
  },
  secondary: {
    main: '#F4F4F8',
  },
  success: {
    main: '#769E91',
  },
  warning: {
    main: '#FF9800',
  },
  text: {
    primary: palette.dark[700],
    secondary: palette.dark[500],
    disabled: palette.dark[300],
  },
  divider: palette.dark[100],
  background: {
    paper: '#FFF',
    default: palette.dark[50],
  },
  action: {
    selectedOpacity: 0,
    selected: palette.dark[50],
  },
};
